<app-categories-button></app-categories-button>

<ng-container *ngIf="attributes?.length">
  <div class="relative" *ngIf="isDesktop; else mobileTmp">
    <app-button-reset-filters></app-button-reset-filters>

    <app-catalog-filters
      class="scrollable-y max-h-filters"
      di-overscrollY
      [attributes]="attributes"
    ></app-catalog-filters>
  </div>
</ng-container>

<ng-template #mobileTmp>
  <app-button-reset-filters></app-button-reset-filters>
  
  <app-catalog-filters [attributes]="attributes"></app-catalog-filters>
</ng-template>
